module.exports = __webpack_public_path__ + "img/Telefone.52439c84.png";